import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Chart from "react-apexcharts";

const ColumnsChart = ({ data }) => {
    const [series, setSeries] = useState([]);
    const [options, setOptions] = useState({});

    useEffect(() => {
        if (!data) return;

        setSeries([
            { name: "Pending", data: [data.pending || 0] },
            { name: "Completed", data: [data.completed || 0] },
        ]);

        setOptions({
            chart: { type: "bar", height: 250, toolbar: { show: false } },
            theme: {
                mode: "dark",   // ENABLE DARK MODE
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: "20%",
                    endingShape: "rounded"
                }
            },
            dataLabels: { enabled: false },
            stroke: { show: true, width: 2, colors: ["transparent"] },
            xaxis: { categories: [data.jobSiteName || "Jobsite"] },
            yaxis: { min: 0, title: { text: "Count" } },
            fill: { opacity: 1 },
            colors: ["#f39c12", "#27ae60"],
            legend: { position: "top" },
            title: {
                text: `JobSite Visits`,
                align: "center",
                margin: 20, // padding top and bottom
                style: {
                    fontSize: "16px",
                    fontWeight: "bold"
                },
            },
        });
    }, [data]);

    if (!data) return <div>No data available</div>;

    return <Chart options={options} series={series} type="bar" height={250} />;
};

// PropTypes validation
ColumnsChart.propTypes = {
    data: PropTypes.shape({
        pending: PropTypes.number,
        completed: PropTypes.number,
        jobSiteName: PropTypes.string,
    }),
};

ColumnsChart.defaultProps = {
    data: { pending: 0, completed: 0, jobSiteName: "Jobsite" },
};

export default ColumnsChart;
